import React, { useEffect, useRef } from "react";

import Chart from "chart.js";
import "chartjs-plugin-deferred";

export const options = {
  lineTension: 0,
  fill: false,
  pointRadius: 2,
  borderWidth: 2.5,
  borderColor: "#e6e6e6",
  pointBorderWidth: 0,
  pointHitRadius: 4
};
export const colors = ["#ff3700", "#43b5e5", "#a05c0f", "#1e9d8b", "#efbd46", "#00ac54"];

// add config to render ticks properly and extra xAxis for line values

const Graph = (props) => {
  let chartInstance = null;
  const chartRef = useRef(null);
  useEffect(() => {
    if (!chartInstance) {
      Chart.Legend.prototype.afterFit = function() {
        this.height = this.height + 15;
      };
    
      chartInstance = new Chart(chartRef.current.getContext("2d"), {
        type: "line",
        data: props.data,
        options: {
          ...options,
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            fontSize: 14,
            fontColor: "#808080",
            text: props.title,
            padding: 0,
            position: "top"
          },
          tooltips: {
            mode: "x",
            position: "nearest",
          },
          legend: {
            position: "top",
            onClick: () => {},
            labels: {
              usePointStyle: true,
              boxWidth: 7,
              fontColor: "#808080",
              fontSize: 11,
              padding: 10
            },
          },
          scales: {
            xAxes: [
              {
                scaleLabel: {
                  labelString: 'f(Hz)',
                  display: true,
                },
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
                ticks: {
                  fontSize: 11,
                  fontColor: "#000000",
                  padding: 0,
                },
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: true,
                  drawBorder: false,
                },
                ticks: {
                  stepSize: 0.1,
                  autoSkip: true,
                  maxTicksLimit: 10,
                  min: 0,
                  suggestedMax: 1,
                  padding: 10,
                  fontSize: 11,
                  fontColor: "#000000",
                  callback: (value) => {
                    return value.toFixed(2);
                  }
                },
              },
            ],
          },
          plugins: {
            deferred: {
              yOffset: "100%",
              delay: 500,
            },
          },
        },
      });
    }
  });
  return (
    <div className="product-chart">
      <canvas ref={chartRef}></canvas>
    </div>
  );
};
export default Graph;
